import React from 'react';

function Footer(){
    return (
        <footer className="main-footer text-center">
        {/* &copy;{(new Date()).getFullYear()} <a href="https://topventory.com" className='text-muted text-underline'>Topventory Software</a>. */}
        Powered by <a target="_blank" href="https://topventory.com" className='text-muted'>Topventory Software</a>
        </footer>
    )
}

export default Footer;
